<template>
	<table class="view_tbl">
		<colgroup>
			<col style="width:180px;" />
			<col style="width:120px;" />
			<col style="" />
		</colgroup>
		<tbody>
			<tr v-for="s in settings" v-bind:key="s.setting_key">
				<th>{{ s.name }}</th>
				<td>
					<span v-if="['ar_email_country', 'stmt_email_country'].includes(s.setting_key)" class="int_type_no_border mgr_15">
						<CodeSelectMultiS :showDesc="false" :selectedCodesWidth="120" :codes="countries" v-model.trim="s.setting_value" :separator="separator" />
					</span>
					<span v-else-if="['ar_sms_payment_term', 'ar_email_payment_term', 'stmt_email_payment_term'].includes(s.setting_key)" class="int_type_no_border mgr_15">
						<CodeSelectMultiS :showDesc="false" :selectedCodesWidth="120" :codes="paymentTermCodes" v-model.trim="s.setting_value" :separator="separator" />
					</span>
					<span v-else-if="s.setting_key === 'stmt_email_date'" class="int_type_no_border mgr_15">
						<select @change="concatStrByDelim(s, $event)">
							<option :value="null" disabled selected></option>
							<option v-for="i in 31" :value="i" :key="i">{{ i }}</option>
						</select>
						<input type="text" v-model.trim="s.setting_value" class="tbl_int sm_int" style="width: 120px;" @focus="$event.target.select()" />
					</span>
					<span v-else-if="['ar_sms_days_in_advance', 'ar_email_days_in_advance'].includes(s.setting_key)" class="int_type_no_border mgr_15">
						<select @change="concatStrByDelim(s, $event)">
							<option :value="null" disabled selected></option>
							<option v-for="i in 31" :value="i" :key="i">{{ i }}</option>
						</select>
						<input type="text" v-model.trim="s.setting_value" class="tbl_int sm_int" style="width: 120px;" @focus="$event.target.select()" />
					</span>
					<input v-else type="text" v-model="s.setting_value" maxlength="1000" class="tbl_int sm_int" style="width:230px;" @focus="$event.target.select()" />
				</td>
				<td>{{ s.description }}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
import { apiSelectCodeList } from '@/api/basicinfo/code';
import CodeSelectMultiS from '@/components/common/CodeSelectMultiS';
export default {
	data: () => ({
		separator: '|',
		paymentTermCodes: [],
		countries: [],
	}),
	components: {
		CodeSelectMultiS,
	},
	props: {
		settings: {
			type: Array,
		},
	},
	watch: {
		settings: {
			handler() {
				this.getData();
			},
		},
	},
	methods: {
		concatStrByDelim(setting, event) {
			const value = event.target.value;
			if (setting.setting_value) {
				const value_arr = setting.setting_value.split(this.separator);
				if (value_arr.every(val => val !== value)) setting.setting_value += this.separator + value;
			} else {
				setting.setting_value = value;
			}
		},
		async selectCountries() {
			let { data } = await apiSelectCodeList({
				code_type: 'CO',
				active_yn: 'A',
			});

			this.countries = data.codeList;
		},
		async selectPaymentTermCodes() {
			let { data } = await apiSelectCodeList({
				code_type: 'PT',
				active_yn: 'A',
			});

			this.paymentTermCodes = data.codeList;
		},
		async getData() {
			await this.selectPaymentTermCodes();
			await this.selectCountries();
		},
	},
};
</script>

<style></style>
